import React from 'react';
import ErrorPage from 'components/ErrorPage';

const UnAuthorized = () => <ErrorPage code='500' msg='系统发生错误' />;

export default React.memo(UnAuthorized);
